import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ProvidesThemeColor } from './provides-theme-color';

@Injectable({
  providedIn: 'root',
})
export class BrowserThemeService {
  private originalThemeColor: string;

  constructor(private meta: Meta) {}

  public set activeThemeColor(desiredColor: string) {
    this.originalThemeColor = this.originalThemeColor || this.activeThemeColor;
    this.meta.updateTag(
      {
        name: 'theme-color',
        content: desiredColor,
      },
      'name="theme-color"'
    );
  }

  public get activeThemeColor(): string {
    return this.themeColorTag?.content;
  }

  public setThemeColorFrom(element: ProvidesThemeColor) {
    this.activeThemeColor = element.desiredThemeColor;
  }

  public restoreOriginalThemeColor() {
    this.activeThemeColor = this.originalThemeColor;
  }

  private get themeColorTag() {
    return this.meta.getTag('name="theme-color"');
  }
}
